---
meta:
  - title: Qué es y para qué funciona - IUSPRO Docs
  - description: Introducción a los exámenes de práctica para estudiantes y profesionales del derecho.
---

# Exámenes de práctica

Los exámenes de práctica le permiten generar pruebas de selección múltiple basadas en normativa y jurisprudencia costarricense para prepararse antes de sus evaluaciones.

## ¿Para quién es esta función?

Esta función es útil para cualquier persona que necesite evaluar o reforzar sus conocimientos legales:

- **Estudiantes de derecho** preparándose para exámenes universitarios
- **Profesionales** cursando maestrías, doctorados o especializaciones
- **Abogados** que quieran profundizar en un área específica del derecho

Cada pregunta generada incluye la respuesta correcta, una explicación detallada y una cita directa de la fuente legal que la respalda.

## ¿Cómo se crean los exámenes?

### Paso 1: Indique los temas

En la pantalla de creación, escriba los temas sobre los que quiere practicar. Puede ser:

- El nombre de una o varias leyes (por ejemplo, "Código de Trabajo")
- Un tema general (por ejemplo, "contratos civiles, arrendamiento y compraventa")
- Una combinación de ambos

### Paso 2: Material de estudio (opcional)

Puede subir hasta 5 archivos como material complementario (PDF o Word). Al subir archivos, el sistema le permite:

- **Distribuir el porcentaje** de preguntas entre sus archivos y la normativa costarricense
- **Reutilizar archivos** de exámenes anteriores sin tener que subirlos de nuevo
- Decidir si quiere que las preguntas vengan solo de sus archivos, solo de la normativa, o de una combinación

### Paso 3: Configure el examen

- **Cantidad de preguntas**: Elija entre 20 o 40 preguntas
- **Cantidad de exámenes**: Puede generar de 1 a 5 exámenes a la vez con los mismos temas para tener más variedad de práctica

### Paso 4: Generar

Haga clic en **Generar Examen**. El sistema buscará contenido legal relevante, generará las preguntas y verificará la precisión de las respuestas. Puede navegar a otra página mientras se genera; recibirá una notificación cuando esté listo.

## Lista de exámenes

En la sección **Mis Exámenes** verá todos los exámenes que ha creado. Para cada uno se muestra:

- **Título** (generado automáticamente)
- **Estado**: Generando, Listo, Completado o En progreso
- **Puntuación** (si ya lo completó)
- **Si está compartido** con otras personas

También tiene la pestaña **Compartidos conmigo** donde verá los exámenes que otras personas han compartido con usted.

## Detalle del examen

Al entrar a un examen verá todas las preguntas en modo de vista previa (sin las respuestas visibles). Desde aquí puede:

- **Comenzar el examen** para responderlo
- **Compartirlo** con otras personas
- **Eliminarlo** si ya no lo necesita

## Créditos

Cada generación de examen consume 1 crédito de chat de su plan. Si genera 3 exámenes a la vez, se consumen 3 créditos.

## Próximos pasos

- Aprenda a [practicar con un examen](/guias/examenes-practicar)
- Aprenda a [compartir exámenes](/guias/examenes-compartir)
